// extracted by mini-css-extract-plugin
module.exports = {"oTextGradient":"_text_gradient-module--o-text-gradient--jBaT2"};